// extracted by mini-css-extract-plugin
export default {"tooltipCard":"PieCardContent_tooltipCard__7FhyV","tooltipCardContent":"PieCardContent_tooltipCardContent__URjCb","pieContainer":"PieCardContent_pieContainer__THcHg"};